// Module
var code = `<div class="add-overlay-screen">
    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.instrumentLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraInstrumentLookup mayContainTrees="true" focused="true" name="insLookup" />
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.dataLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraComboBox name="sourceTypeComboBox" />
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.priceLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraComboBox name="priceScalingComboBox" />
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.styleLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraComboBox name="chartStyleComboBox" />
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.barsBodyLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <pairColorPicker name="barsBodyPicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.barsBorderLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <pairColorPicker name="barsBorderPicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.wickLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <pairColorPicker name="wickPicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.dojiLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraButtonColorPicker name="dojiPicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.histogramLineLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraButtonColorPicker name="histogramPicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.barsHiLowLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraButtonColorPicker name="linePicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-container">
        <terceraLabel text="{{.Resources.getResource('OverlayScreen.solidPriceLabel')}}" />

        <div class="add-overlay-screen-container-right-position">
            <terceraButtonColorPicker name="solidPricePicker" colorPickerClicked="{{@this.onColorPickerClicked}}"/>
        </div>
    </div>

    <div class="add-overlay-screen-button-container">
        <div class="add-overlay-screen-CheckBox-container">
            <reactFormLabel label="{{.Resources.getResource('OverlayScreen.priceMarkerCheckbox')}}">
                <reactCheckbox 
                    checked="{{.showPriceMarker}}" 
                    on-onChange="@this.onShowPriceMarkerChanged(\$1)" />
            </reactFormLabel>
        </div>
        <div class="add-overlay-screen-container-right-position">
            <terceraButton name="ok"
                           terceraButtonStyle="js-button-ok"
                           text="{{.okButtonText}}"
                           on-btnClick="okEvent" />

            <terceraButton name="cancel"
                           terceraButtonStyle="js-button-gray25"
                           text="{{.cancelButtonText}}"
                           on-btnClick="cancelEvent" />
        </div>
    </div>
</div>`;
// Exports
export default code;